export default "__VITE_ASSET__jiihg3Q9__"